
export const baseIconProps = {
  size: {
    type: String,
    default: '14px',
  },
  spin: {
    type: [Boolean, String],
    default: false,
  },
};


export function useBaseIcon (props) {
  if (props.spin)
    return [ 'icon--spin' ];
}
